import React from "react";
import { Hero } from "./components/Hero";
import { StatsStrip } from "./components/StatsStrip";
import { ProblemsSection } from "./components/ProblemsSection";
import { SolutionSection } from "./components/SolutionSection";
import { BehindCnsSection } from "./components/BehindCnsSection";
import { ContentSection } from "./components/ContentSection";
import { SamplesSection } from "./components/SamplesSection";
import { BonusSection } from "./components/BonusSection";
import { OfferSection } from "./components/OfferSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { FaqSection } from "./components/FaqSection";
import { ClosingSection } from "./components/ClosingSection";
import { Footer } from "./components/Footer";
import { StickyBar } from "./components/StickyBar";
import { useMetaPixel } from "./hooks/useMetaPixel";
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full overflow-x-hidden bg-night font-sans" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <main data-id="element-1" data-mp="3mljat0fdtn5p">
        <Hero data-id="element-2" data-mp="3mlaxj7fckftz" />
        <StatsStrip data-id="element-3" data-mp="3mkrbpfmkt7ao" />
        <ProblemsSection data-id="element-4" data-mp="3mk84otygs3bf" />
        <SolutionSection data-id="element-5" data-mp="3mjg7xft4rzjk" />
        <BehindCnsSection data-id="element-6" data-mp="3rcj6k2crlz6m" />
        <ContentSection data-id="element-7" data-mp="3rdapodp6e4g0" />
        <SamplesSection data-id="element-8" data-mp="3rcsuzli5vya7" />
        <BonusSection data-id="element-9" data-mp="3relw6la09qat" />
        <OfferSection data-id="element-10" data-mp="6hqffdy0fe4" />
        <TestimonialsSection data-id="element-11" data-mp="4wwnrzgd0hb" />
        <GuaranteeSection data-id="element-12" data-mp="56qjqnmbrsa" />
        <FaqSection data-id="element-13" data-mp="2zl3cjn8vpa6d" />
        <ClosingSection data-id="element-14" data-mp="2zlv6ktmtuzuj" />
      </main>
      <Footer data-id="element-15" data-mp="2zmo89g6xiz5t" />
      <StickyBar data-id="element-16" data-mp="2zn6cayzu2hoa" />
    </div>;
}